import { getToken } from '../../Utils/authUtils';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { REPORTS } from '../../constant';

interface Args {
  reportId?: string;
  studyInstanceUID?: string;
}

// Fetch the structured measurement document for a report (or study).
export const getStructuredMeasurements = createAsyncThunk(
  'getStructuredMeasurements',
  async ({ reportId, studyInstanceUID }: Args, { rejectWithValue }) => {
    try {
      if (!reportId && !studyInstanceUID) {
        throw new Error('reportId or studyInstanceUID is required');
      }

      const params = new URLSearchParams();
      if (reportId) params.set('reportId', reportId);
      if (studyInstanceUID) params.set('studyInstanceUID', studyInstanceUID);

      const response = await fetch(
        `${REPORTS.GET_STRUCTURED_MEASUREMENTS}?${params.toString()}`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${getToken()}`,
          },
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        return rejectWithValue(errorData.message || 'Get measurements failed');
      }

      const result = await response.json();
      return result;
    } catch (error: any) {
      return rejectWithValue(error.message || 'An error occurred');
    }
  }
);
